import React from 'react'
import Link from 'gatsby-link'

const MovingSquares = () => (
  <div className="squares">
    <div className="square square-a"></div>
    <div className="square square-b"></div>
    <div className="square square-c"></div>
    <div className="square square-d"></div>
    <div className="square square-e"></div>
    <div className="square square-f"></div>
  </div>
)

export default MovingSquares



// WEBPACK FOOTER //
// ./src/components/moving-squares.js